module.exports = __webpack_public_path__ + "img/fenge.e300e188.png";